import { createAction } from '../../../../../store.model';
import { ActionType } from '../commitment-narrative.action';
import { RowActionType } from '../models/row-action-type.enum';

export interface UpdateOrRemoveNote {
    actionType: RowActionType;
    content?: string;
    id: string;
}

export const updateOrRemoveNote = createAction<ActionType, UpdateOrRemoveNote>(
    ActionType.COMMITMENT_NARRATIVE__UPDATE_OR_REMOVE_NOTE,
);
